import useSidebarStore from '@entities/ui/model/useSidebarStore';
import GlobalFooter from '@shared/components/organisms/GlobalFooter/GlobalFooter';
import GlobalHeader from '@shared/components/organisms/GlobalHeader/GlobalHeader';
import Sidebar from '@shared/components/organisms/Sidebar/Sidebar';

import styles from './MainLayout.module.scss';

/**
 * MainLayout 컴포넌트
 * - 애플리케이션 공통 레이아웃 (헤더, 사이드바, 푸터 포함)
 * - 모든 인증된 페이지에서 사용
 */
export default function MainLayout({ children }) {
  const { isOpen: isSidebarOpen } = useSidebarStore();

  return (
    <div className={styles.layout}>
      <GlobalHeader />
      <div className={styles.body}>
        <Sidebar />
        {/* scrollContainer: 
          가로 스크롤바를 푸터 아래에 위치시키기 위해  메인 콘텐츠와 푸터를 모두 감싸는 최외곽 스크롤 박스 
        */}
        <div
          className={`${styles.scrollContainer} ${!isSidebarOpen ? styles.scrollContainerExpanded : ''}`}
        >
          <div className={styles.mainWrapper}>
            <main className={styles.main}>{children}</main>
            {/* 푸터가 메인 콘텐츠와 함께 가로로 스크롤되도록 이 위치에 배치 */}
            <GlobalFooter />
          </div>
        </div>
      </div>
    </div>
  );
}
